import { COURSE_STATUS } from '@/constants/course-status'

export interface WorkloadEntry {
  workload?: number
  statusId?: string
}

export interface WorkloadSummary {
  grantedWorkload: number
  totalWorkload: number
  percentage: number | null
}

export function sanitizeWorkload(workload?: number | null) {
  const value = Number(workload)
  return Number.isFinite(value) ? value : 0
}

export function sumWorkload(items?: { workload?: number }[]) {
  return (items ?? []).reduce(
    (acc, item) => acc + sanitizeWorkload(item?.workload),
    0
  )
}

export function calculateWorkloadSummary(
  entries: WorkloadEntry[],
  curriculumCourses?: { workload?: number }[]
): WorkloadSummary {
  const grantedWorkload = sumWorkload(
    entries.filter((entry) => entry.statusId === COURSE_STATUS.GRANT.id)
  )
  const totalWorkload = sumWorkload(curriculumCourses)
  const percentage =
    totalWorkload > 0
      ? Math.round((grantedWorkload / totalWorkload) * 100)
      : null

  return { grantedWorkload, totalWorkload, percentage }
}
